import { useEffect, useState } from 'react';

import { canGenerateReport, getRemainingCooldown } from '../Services/exportReportService';

// Hook para controlar cooldown de relatórios
const useReportCooldown = (reportType) => {
  const [cooldownSeconds, setCooldownSeconds] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      if (!canGenerateReport(reportType)) {
        const remaining = getRemainingCooldown(reportType);
        setCooldownSeconds(remaining);
      } else {
        setCooldownSeconds(0);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [reportType]);

  return cooldownSeconds;
};

export default useReportCooldown;
